import { get, find } from 'lodash'

function getLikeId(likes, userId) {
  const like = find(likes, { userId })
  return get(like, 'id')
}

export default getLikeId
